import React, { PropsWithChildren } from 'react';
import { Header, HeaderProps } from '@/ui/molecules/Header';
import { Footer, FooterProps } from '@/ui/molecules/Footer';
import Grid from '@mui/material/Grid2';
import useCustomCSS from '@/ui/hooks/useCustomCSS';
import { Box } from '@mui/material';
import { TemplateType } from '@/api/tax-guide';
import useDynamicFont from '@/ui/hooks/useDynamicFont';

type LayoutProps = {
  header: HeaderProps;
  footer: FooterProps;
  folderName?: string;
  template: TemplateType;
};

export const Layout = ({
  header,
  footer,
  folderName,
  template,
  children,
}: PropsWithChildren<LayoutProps>) => {
  useCustomCSS({ folderName, template });
  useDynamicFont({ folderName, template });

  return (
    <Grid container>
      <Grid size={{ xs: 12 }}>
        <Header {...header} />
      </Grid>
      <Grid size={{ xs: 10, sm: 10, md: 7 }} margin={'auto'}>
        <Box sx={{}}>{children}</Box>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Footer {...footer} />
      </Grid>
    </Grid>
  );
};
